// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sectionTitle":"_3ZzPmg","pensionTitle":"_1FFuHm","selectGroup":"kpw1qO","retirementAge":"muWu_3","retirementAgeLabel":"_27n2xP","link":"_3LU3G-","infoBtn":"_2Q-4YU"};